// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3R0GY","tab":"Tabs_tab__1CFV9","tabActive":"Tabs_tabActive__1lo4R"};